import { render, staticRenderFns } from "./Expressoes.vue?vue&type=template&id=6e12c68d&scoped=true&"
import script from "./Expressoes.vue?vue&type=script&lang=js&"
export * from "./Expressoes.vue?vue&type=script&lang=js&"
import style0 from "./Expressoes.vue?vue&type=style&index=0&id=6e12c68d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e12c68d",
  null
  
)

export default component.exports